import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
const testimonios = [{
  id: 1,
  name: 'María González',
  location: 'Buenos Aires, Argentina',
  text: 'Por fin algo que los mantiene entretenidos sin tener que darle el celular. Mis hijos pasan horas coloreando juntos en la mesa. Fue lo mejor que compré este año.'
}, {
  id: 2,
  name: 'Carolina Pérez',
  location: 'Córdoba, Argentina',
  text: 'Lo descargué un domingo y desde entonces mi hija pide colorear en vez de pedirme la tablet. Estoy mucho más tranquila viéndola crear en lugar de mirar videos.'
}, {
  id: 3,
  name: 'Ana Martínez',
  location: 'Rosario, Argentina',
  text: 'Lo que más me sorprendió fue verlos concentrados durante una hora seguida. Sin gritos, sin pantallas. Compartimos un momento increíble en familia.'
}, {
  id: 4,
  name: 'Lucía Fernández',
  location: 'Mendoza, Argentina',
  text: 'Llevamos la carpeta a todos lados. Restaurantes, viajes, casa de los abuelos. Donde antes era pelearse por el celular, ahora se sientan a colorear.'
}, {
  id: 5,
  name: 'Daniela Ruiz',
  location: 'La Plata, Argentina',
  text: 'Tengo dos hijos de edades distintas y a los dos les encanta. Imprimo a la mañana y tengo entretenimiento garantizado para toda la tarde. Valió cada peso.'
}, {
  id: 6,
  name: 'Florencia Sánchez',
  location: 'Mar del Plata, Argentina',
  text: 'Buscaba algo para reducir el tiempo de pantalla y esto superó mis expectativas. Mi hijo desarrolló una creatividad que no le conocía. Súper recomendado.'
}];
export const Testimonios: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setDirection(1);
      setCurrentIndex(prev => (prev + 1) % testimonios.length);
    }, 5500);
    return () => clearInterval(timer);
  }, [currentIndex]);
  const nextSlide = () => {
    setDirection(1);
    setCurrentIndex(prev => (prev + 1) % testimonios.length);
  };
  const prevSlide = () => {
    setDirection(-1);
    setCurrentIndex(prev => (prev - 1 + testimonios.length) % testimonios.length);
  };
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 80 : -80,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      x: direction < 0 ? 80 : -80,
      opacity: 0
    })
  };
  const t = testimonios[currentIndex];
  return <section className="py-8 px-4 bg-cream-dark/50 overflow-hidden" data-id="element-196">
      <div className="max-w-2xl mx-auto" data-id="element-197">
        <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet text-center leading-tight mb-8" data-id="element-198">
          Lo que dicen quienes{' '}
          <span className="text-gold-dark" data-id="element-199">ya la descargaron</span>
        </h2>

        <div className="relative" data-id="element-200">
          <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-201">
            <motion.div key={currentIndex} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
            duration: 0.35,
            ease: 'easeInOut'
          }} data-id="element-202">
              <div className="bg-white p-6 sm:p-8 rounded-3xl border-2 border-gold/40 shadow-2xl relative" data-id="element-203">
                <Quote className="absolute top-4 right-4 text-gold/30 w-12 h-12" data-id="element-204" />

                <div className="flex gap-0.5 mb-3" data-id="element-205">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-dark text-gold-dark" data-id="element-206" />)}
                </div>

                <p className="text-violet text-base sm:text-lg leading-relaxed font-semibold mb-4" data-id="element-207">
                  "{t.text}"
                </p>

                <div className="border-t-2 border-dashed border-cream-dark pt-3" data-id="element-208">
                  <p className="font-rounded font-bold text-violet text-base sm:text-lg leading-tight" data-id="element-209">
                    {t.name}
                  </p>
                  <p className="text-xs sm:text-sm text-textsoft font-semibold" data-id="element-210">
                    {t.location}
                  </p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="flex items-center justify-center gap-4 mt-5" data-id="element-211">
            <button onClick={prevSlide} className="bg-violet text-cream p-2 rounded-full shadow-md hover:bg-violet-light transition-colors" aria-label="Anterior" data-id="element-212">
              <ChevronLeft size={20} data-id="element-213" />
            </button>

            <div className="flex gap-1.5" data-id="element-214">
              {testimonios.map((_, idx) => <button key={idx} onClick={() => {
              setDirection(idx > currentIndex ? 1 : -1);
              setCurrentIndex(idx);
            }} className={`h-2 rounded-full transition-all ${idx === currentIndex ? 'bg-gold-dark w-6' : 'bg-gold/40 w-2'}`} aria-label={`Ir al testimonio ${idx + 1}`} data-id="element-215" />)}
            </div>

            <button onClick={nextSlide} className="bg-violet text-cream p-2 rounded-full shadow-md hover:bg-violet-light transition-colors" aria-label="Siguiente" data-id="element-216">
              <ChevronRight size={20} data-id="element-217" />
            </button>
          </div>
        </div>
      </div>
    </section>;
};